import { enumSchema } from "vue-utils"

export enum MarriageStatus {
	Cancelled = "Cancelled",
	Incomplete = "Incomplete",
	P1Incomplete = "P1Incomplete",
	P1Complete = "P1Complete",
	P2Incomplete = "P2Incomplete",
	P87 = "P87",
	P2Complete = "P2Complete",
}

export const MarriageStatusSchema = enumSchema(MarriageStatus)
